import React from 'react'

/* eslint-disable @typescript-eslint/no-unused-vars */
const MenuContext = React.createContext({
  setValue: (item: any, path: any[]) => {},
  activePath: [] as any[],
  setForceExpanded: (force: boolean) => {},
  forceExpanded: false,
})
/* eslint-enable */

export const useSelectDropdownMenu = () => {
  return React.useContext(MenuContext)
}

export const MenuContextProvider = MenuContext.Provider
